const serviceWorkerUpdate = (registration) => {
  return async function (dispatch) {
    dispatch({ type: 'SW_UPDATE', payload: registration })
  }
}

export { serviceWorkerUpdate }
